import { render } from "./Form.vue?vue&type=template&id=36d73e41"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=36d73e41&lang=scss"
script.render = render

export default script